export const GET_IMPORT_INFO = "GET_IMPORT_INFO";
export const START_LOADING_IMPORT_INFO = "START_LOADING_IMPORT_INFO";
export const ERROR_LOADING_IMPORT_INFO = "ERROR_LOADING_IMPORT_INFO";
export const STOP_LOADING_IMPORT_INFO = "STOP_LOADING_IMPORT_INFO";
export const RESET_IMPORT_INFO = "RESET_IMPORT_INFO";
